import { PreviewList } from "features/CenterContent/VehicleDetails/TrainDetails/TrainCondition/OperationalTrainInfo/TrainInfoModal/PreviewList";
import { TrainInfoBatchFormProps } from "features/CenterContent/VehicleDetails/TrainDetails/TrainCondition/OperationalTrainInfo/TrainInfoModal/TrainInfoBatchForm";
import {
  TrainFormGroup,
  TrickFormHookGroupedTrainFormSchema,
} from "features/CenterContent/VehicleDetails/TrainDetails/TrainCondition/OperationalTrainInfo/TrainInfoModal/types/formSchema";
import { useTrainInfoBatchPreviews } from "features/CenterContent/VehicleDetails/TrainDetails/TrainCondition/OperationalTrainInfo/TrainInfoModal/useTrainInfoBatchPreviews";
import { FC } from "react";
import { useWatch } from "react-hook-form";
import { getFieldFromNestedObject } from "shared/utils/objectUtils";

export const BatchPreview: FC<TrainInfoBatchFormProps> = ({
  activeTrainSeriesKey,
}) => {
  const formData = useWatch<TrickFormHookGroupedTrainFormSchema>();
  // Read comment in SubTypeInput.tsx
  const formDataGroups = getFieldFromNestedObject(
    formData,
    activeTrainSeriesKey,
  ) as TrainFormGroup[];
  const { previewData, previewStatus } = useTrainInfoBatchPreviews({
    formData: formDataGroups,
  });
  return (
    <PreviewList
      previewStatus={previewStatus}
      previewData={previewData?.map((it) => it.preview)}
    />
  );
};
